module.exports = __webpack_public_path__ + "static/widernet-web-1-83a2df2214fc45d81504603f3cc716b2.jpg";